// Select all elements with the class 'swatch_button Size-button'
const buttons = document.querySelectorAll(
    "input.swatch_button.Size-button, input.swatch_button.color-swatch"
);
var inventoryThreshold = parseInt(
    window.PXUTheme.theme_settings.inventory_threshold
);
const product_count_one = window.PXUTheme.translation.product_count_other;
const product = JSON.parse(
    document.querySelector(".product_form").dataset["product"]
);

function initializeProductImages() {
    // Determine if the viewport is desktop
    const isDesktop = window.innerWidth > 768;

    // Get all selected swatch options
    const selectedOptions = Array.from(
        document.querySelectorAll(".swatch input:checked")
    ).map((input) => input.value);

    // Select the product gallery
    const gallery = document.querySelector(".product-gallery");

    // If gallery exists and we're on desktop, proceed with image filtering
    if (gallery && isDesktop) {
        if (selectedOptions.length > 0) {
            // Use the first selected option to filter images
            const option1 = selectedOptions[0];

            // Get all images in the gallery
            const allImages = gallery.querySelectorAll("img");

            // Hide all images
            allImages.forEach((img) => {
                img.style.display = "none";
            });

            // Show images matching the selected option or "All"
            const matchingImages = gallery.querySelectorAll(
                `img[alt="${option1}"], img[alt="All"]`
            );
            matchingImages.forEach((img) => {
                img.style.display = "block";
            });
        }
    } else if (gallery && !isDesktop) {
        // On mobile, show all images
        const allImages = gallery.querySelectorAll("img");
        allImages.forEach((img) => {
            img.style.display = "block";
        });
    }
}

// Event listener to handle changes in swatch selection and window resizing
function attachEventListeners() {
    // Reinitialize on swatch selection change
    document.querySelectorAll(".swatch input").forEach((input) => {
        input.addEventListener("change", initializeProductImages);
    });

    // Reinitialize on window resize to handle desktop/mobile behavior
    window.addEventListener("resize", initializeProductImages);
}

function initializeColorSwatches() {
    const availableOptions = product.variants
        .filter(v => v.available)
        .map(v => v.option1);
    const uniqueOptions = [...new Set(availableOptions)];

    // Update color swatches
    $(parent + ' .swatch[data-option-index="0"] .swatch-element').each(function () {
        if (uniqueOptions.includes($(this).attr("data-value"))) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("disabled", true);
        }
    });

    // Get the selected color (option1)
    const selectedColor = $(parent + ' .swatch[data-option-index="0"] input:checked').val();

    // Find available sizes for the selected color
    const availableSizes = product.variants
        .filter(v => v.available && v.option1 === selectedColor)
        .map(v => v.option2);

    // Update size swatches
    $(parent + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        const sizeValue = $(this).attr("data-value");
        if (availableSizes.includes(sizeValue)) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .prop("disabled", false);

            // Select the first available size if none is selected
            if (!$(parent + ' .swatch[data-option-index="1"] input:checked').length) {
                $(this).find(":radio").prop("checked", true);
            }
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .prop("checked", false)
                .prop("disabled", true);
        }
    });

    // Prevent clicking soldout swatches
    $(parent + ' .swatch[data-option-index="1"] .swatch-element').off('click').on('click', function (e) {
        if ($(this).hasClass('soldout')) {
            e.preventDefault(); // Stop default behavior
            e.stopPropagation(); // Prevent event from bubbling up
            return false;
        }
    });

    // Additionally disable interaction with soldout radio buttons
    $(parent + ' .swatch[data-option-index="1"] .swatch-element.soldout input[type="radio"]').off('click').on('click', function (e) {
        e.preventDefault(); // Stop default behavior
        return false;
    });

    // Hide any size swatches flagged (via accentuate.hide_size) for the color
    // that's now selected. Runs last so it never gets overridden by the
    // soldout pass above. (EvinceDev - Aug 2026)
    applyHideSizeForColor(selectedColor);
}

// Hide the size swatch for the currently selected color when that specific
// (color, size) variant has accentuate.hide_size = true. product__swatch.liquid
// bakes the list of colors that should hide a given size into that size
// swatch-element's data-hide-size-colors attribute; this only ever hides the
// size for the colors listed there, never for other colors or other sizes.
function applyHideSizeForColor(selectedColor) {
    if (!selectedColor) return;

    var hadCheckedHiddenSize = false;

    $(parent + ' .swatch[data-option-index="1"] .swatch-element').each(function () {
        var hideColorsRaw = $(this).attr("data-hide-size-colors") || "";
        var hideColors = hideColorsRaw
            .split(",")
            .map(function (c) { return c.trim(); })
            .filter(Boolean);
        var shouldHide = hideColors.indexOf(selectedColor) !== -1;
        var $radio = $(this).prev(':radio');

        if (shouldHide) {
            $(this).addClass("hide-size");
            $radio.prop("disabled", true);
            if ($radio.prop("checked")) {
                $radio.prop("checked", false);
                hadCheckedHiddenSize = true;
            }
        } else {
            $(this).removeClass("hide-size");
            if (!$(this).hasClass("soldout")) {
                $radio.prop("disabled", false);
            }
        }
    });

    // The size that was selected is hidden for this color - fall back to the
    // first visible, in-stock size so a color change never leaves nothing selected.
    if (hadCheckedHiddenSize) {
        var $fallback = $(parent + ' .swatch[data-option-index="1"] .swatch-element')
            .not(".hide-size")
            .not(".soldout")
            .first();
        if ($fallback.length) {
            var fallbackRadio = $fallback.prev(':radio')[0];
            if (fallbackRadio) {
                fallbackRadio.checked = true;
                fallbackRadio.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const initializeAll = () => {
        handleUrlVariant();
        initializeProductImages();
        attachEventListeners();

        // Add this new function call first
        selectFirstAvailableSize();
        initializeProductText();
        initializeColorSwatches();
    };

    function handleUrlVariant() {
        const url = new URL(window.location.href);
        const variantId = url.searchParams.get("variant");

        if (variantId) {
            // Handle case where variant ID is in URL
            const variant = product.variants.find(v => v.id.toString() === variantId);
            if (variant) {
                selectVariant(variant, true); // Pass true to indicate this is from URL
            } else {
                selectDefaultVariant();
            }
        } else {
            // No variant in URL - select first available variant
            selectDefaultVariant();
        }
    }

    function selectDefaultVariant() {
        // Find first available variant
        const firstAvailableVariant = product.variants.find(v => v.available);

        if (firstAvailableVariant) {
            // Update URL with the default variant
            const url = new URL(window.location.href);
            url.searchParams.set("variant", firstAvailableVariant.id);
            window.history.replaceState({}, "", url);

            selectVariant(firstAvailableVariant);
        }
    }

    function selectVariant(variant, fromUrl = false) {
        // Set color (option1)
        const colorInput = document.querySelector(
            `${parent} .swatch[data-option-index="0"] input[value="${variant.option1}"]`
        );
        if (colorInput) {
            colorInput.checked = true;
            colorInput.dispatchEvent(new Event('change'));
        }

        // Wait for color change to process before setting size
        setTimeout(() => {
            // Set size (option2)
            const sizeInput = document.querySelector(
                `${parent} .swatch[data-option-index="1"] input[value="${variant.option2}"]`
            );
            if (sizeInput) {
                sizeInput.checked = true;
                sizeInput.dispatchEvent(new Event('change'));
            } else if (!fromUrl) {
                // Only select first available size if not loading from URL
                selectFirstAvailableSize();
            }

            // If there's a third option (e.g., inseam), set it
            if (variant.option3) {
                const option3Input = document.querySelector(
                    `${parent} .swatch[data-option-index="2"] input[value="${variant.option3}"]`
                );
                if (option3Input) {
                    option3Input.checked = true;
                    option3Input.dispatchEvent(new Event('change'));
                }
            }
        }, 100);
    }

    function selectFirstAvailableSize() {
        const selectedColor = document.querySelector(
            `${parent} .swatch[data-option-index="0"] input:checked`
        )?.value;

        if (selectedColor) {
            const availableSizes = product.variants
                .filter(v => v.available && v.option1 === selectedColor)
                .map(v => v.option2);

            if (availableSizes.length > 0) {
                // First uncheck all sizes
                document.querySelectorAll(`${parent} .swatch[data-option-index="1"] input`).forEach(input => {
                    input.checked = false;
                });

                // Find and select first available size
                const firstAvailableSize = document.querySelector(
                    `${parent} .swatch[data-option-index="1"] input[value="${availableSizes[0]}"]`
                );
                if (firstAvailableSize) {
                    firstAvailableSize.checked = true;
                    firstAvailableSize.dispatchEvent(new Event('change'));

                    // Update URL with the new variant
                    const newVariant = product.variants.find(
                        v => v.available && v.option1 === selectedColor && v.option2 === availableSizes[0]
                    );
                    if (newVariant) {
                        const url = new URL(window.location.href);
                        url.searchParams.set("variant", newVariant.id);
                        window.history.replaceState({}, "", url);
                    }
                }
            }
        }
    }

    function initializeProductText() {
        const selectedVariant = product.variants.find(
            (item) => item.id.toString() === selectedVariantId
        );

        if (selectedVariant) {
            // Update color text
            const colortextElement = document.getElementById("colortext");
            if (colortextElement && selectedVariant.option1) {
                colortextElement.innerHTML = selectedVariant.option1;
            }

            // Update size text
            const sizeElement = document.getElementById("sizetext");
            const waistElement = document.getElementById("waisttext");
            if (sizeElement && selectedVariant.option2) {
                sizeElement.innerHTML = selectedVariant.option2;
            } else if (waistElement && selectedVariant.option2) {
                waistElement.innerHTML = selectedVariant.option2;
            }

            // Update inseam text
            const inseamElement = document.getElementById("inseamtext");
            if (inseamElement && selectedVariant.option3) {
                inseamElement.innerHTML = selectedVariant.option3;
            }
        }
    }


    // New function to select first available size
    function selectFirstAvailableSize() {
        const selectedColor = $(parent + ' .swatch[data-option-index="0"] input:checked').val();
        if (selectedColor) {
            // Find first available size for the selected color
            const sizeElements = $(parent + ' .swatch[data-option-index="1"] .swatch-element');
            let firstAvailableFound = false;

            // First uncheck all sizes
            sizeElements.find(':radio').prop('checked', false);

            // Then find and select first available size
            sizeElements.each(function () {
                if (!firstAvailableFound && !$(this).hasClass('soldout')) {
                    $(this).find(':radio')
                        .prop('checked', true)
                        .trigger('change');
                    firstAvailableFound = true;
                }
            });

            // If no available size was found, select the first size regardless
            if (!firstAvailableFound && sizeElements.length > 0) {
                sizeElements.first().find(':radio')
                    .prop('checked', true)
                    .trigger('change');
            }
        }
    }

    // Initial load with multiple attempts
    setTimeout(initializeAll, 100);  // Quick first attempt

    window.addEventListener('load', () => {
        setTimeout(initializeAll, 500);  // Backup attempt after full page load
    });
});


// Pre-order update
const $product = $(".product-" + product.id);
const shipDate =
    document.querySelector(".product_form form").parentElement.dataset.shipDate;

// Inventory update
const qty = JSON.parse(
    document.querySelector(".product_form").dataset["variantInventory"]
);
const url = new URL(window.location.href);
const variantValue = url.searchParams.get("variant");
const selectedVariantId =
    document.querySelector(".product_form").dataset["selectedVariant"];
const selectedVariant = product.variants.find(
    (item) => item.id == selectedVariantId
);
var onLoadSoldOut =
    product.variants.filter(
        (variant) => !variant.available && variant.id == variantValue
    ).length > 0
        ? true
        : false;
// Building our mapping object. For Size Avaliable and soldout Update
optionsMap = {};

for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
        // Gathering values for the 1st drop-down.
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = Shopify.uniq(optionsMap["root"]); // Gathering values for the 2nd drop-down.

        if (product.options.length > 1) {
            var key2 = variant.option1;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option2);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        } // Gathering values for the 3rd drop-down.

        if (product.options.length === 3) {
            var key2 = variant.option1 + " / " + variant.option2;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option3);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        }
    }
}
const parent = ".product-" + product.id + " .js-product_section";
var key3 = null;
var key4 = null;
const parentElement = document.querySelector(".select-container"); // Replace `parent` with your actual parent selector

const observer2 = new MutationObserver(function (mutationsList, observer) {
    key3 = $(parent + " .single-option-selector:eq(0)").val();
    key4 = $(parent + " .single-option-selector:eq(1)").val();

    function updateSwatchElements(key, optionIndex) {
        if (key || optionIndex === 0) {
            var availableOptions;
            if (optionIndex === 0) {
                availableOptions = optionsMap["root"] || product.variants
                    .filter(v => v.available)
                    .map(v => v.option1)
                    .filter((v, i, a) => a.indexOf(v) === i);
            } else {
                availableOptions = optionsMap[optionIndex == 1 ? key3 : key3 + " / " + key4];
            }

            if (availableOptions) {
                var sizeChecked = false;
                let firstAvailableOption = null;

                // First pass: mark available/soldout status and find first available option
                $(parent + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled");

                        // Store first available option
                        if (!firstAvailableOption) {
                            firstAvailableOption = this;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");

                        // Uncheck if it's sold out
                        this.previousElementSibling.checked = false;
                    }
                });

                // Second pass: handle selection
                $(parent + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(function () {
                    const isAvailable = $.inArray($(this).attr("data-value"), availableOptions) !== -1;

                    if (isAvailable) {
                        // If this matches the selected variant, select it
                        if (selectedVariant && selectedVariant.options[optionIndex] === this.dataset.value) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    }
                });

                // If no size is checked yet, select the first available option
                if (!sizeChecked && firstAvailableOption) {
                    firstAvailableOption.previousElementSibling.checked = true;
                    sizeChecked = true;

                    // Update URL if needed
                    if (!onLoadSoldOut) {
                        var urlTemp = new URL(window.location.href);
                        urlTemp.searchParams.set(
                            "variant",
                            optionIndex === 0
                                ? firstAvailableOption.previousElementSibling.dataset["availableVariant"]
                                : selectedVariantId
                        );
                        window.history.replaceState({}, "", urlTemp);
                    }
                }
            }
        }
    }

    // Always update option 0 first
    updateSwatchElements(null, 0);
    setTimeout(() => {
        updateSwatchElements(key3, 1);
        updateSwatchElements(key4, 2);
    }, 50);

    if (key3 || key4) {
        if (onLoadSoldOut) {
            var message = window.PXUTheme.translation.soldOut;
            $(".was-price", $product).text("");
            $(".savings", $product).text("");
            $(".preorder-date__wrapper").text(" ");
            $(".current_price", $product).text("");
            $(".items_left", $product).text("");
            $("[data-max-inventory-management]", $product).removeAttr("max");
            $(".sold_out", $product).text(message);
            $("[data-add-to-cart-trigger]", $product)
                .addClass("disabled")
                .attr("disabled", "disabled")
                .find("span:not(.icon)")
                .text(message);
            $(".shopify-payment-button", $product).hide();
            $(".purchase-details__quantity", $product).hide();
            onLoadSoldOut = false;
        }
        initializeProductImages();
        observer2.disconnect();
    }
});

observer2.observe(parentElement, { childList: true, subtree: true });

// Function to handle the event
function handleButtonChange(event) {
    var option1 = $(".product_form form")
        .find(".swatch_options input:checked")
        .eq(0)
        .val();
    var option2 =
        $(".product_form form").find(".swatch_options input:checked").eq(1).val() ||
        "";
    var option3 =
        $(".product_form form").find(".swatch_options input:checked").eq(2).val() ||
        "";

    if (option1 && option2 && option3) {
        var notifyMessage = option1 + " / " + option2 + " / " + option3;
    } else if (option1 && option2) {
        var notifyMessage = option1 + " / " + option2;
    } else {
        var notifyMessage = option1;
    }
    var variant = null;
    if (option3 != "") {
        variant = product.variants.find(
            (item) => item.title === (option1 + " / " + option2) && item.available
        );
        variant =
            product.variants.find(
                (item) => item.title === notifyMessage && item.available
            ) != undefined
                ? product.variants.find(
                    (item) => item.title === notifyMessage && item.available
                )
                : variant;
        if (variant == null) {
            variant = product.variants.find(
                (item) => item.title.startsWith(option1 + " /") && item.available
            );
        }
    } else {
        variant = JSON.parse(event.target.dataset["variant"]);
        if (!variant.available || variant.options[0] != option1) {
            variant = product.variants.find(
                (item) => item.title.startsWith(option1 + " /") && item.available
            );
        }
    }
    // Check if the button is checked
    if (event.target.checked) {
        //Uncheck the sold out size
        if (event.target.name[event.target.name.length - 1] === "1") {
            if (!optionsMap[variant.options[0]].includes(event.target.ariaLabel)) {
                var temp_variant = product.variants.find(
                    (item) =>
                        item.id.toString() ===
                        new URL(window.location.href).searchParams.get("variant")
                );
                document.getElementById(
                    "swatch-1-" + temp_variant.options[1].toLowerCase() + "-" + product.id
                ).checked = true;
                return;
            }
        }
        if (event.target.name[event.target.name.length - 1] === "2") {
            if (
                !optionsMap[variant.options[0] + " / " + variant.options[1]].includes(
                    event.target.ariaLabel
                )
            ) {
                var temp_variant = product.variants.find(
                    (item) =>
                        item.id.toString() ===
                        new URL(window.location.href).searchParams.get("variant")
                );
                document.getElementById(
                    "swatch-2-" + temp_variant.options[2].toLowerCase() + "-" + product.id
                ).checked = true;
                return;
            }
        }
        if (
            option3 == "" &&
            option2 != "" &&
            option1 != "" &&
            !event.target.classList.contains("color-swatch")
        ) {
            variant = product.variants.find(
                (item) =>
                    item.title === (option1 + " / " + option2) && item.available
            );
        }
        if (variant.options[0] !== undefined) {
            option1 = variant.options[0];
        }
        if (variant.options[1] !== undefined) {
            option2 = variant.options[1];
        }
        if (variant.options[2] !== undefined) {
            option3 = variant.options[2];
        }

        if (option1 !== "") {
            const colortextElement = document.getElementById("colortext");
            if (colortextElement) {
                colortextElement.innerHTML = option1; // Update the color text
            }

            // Get the selected variant from the event target
            const variants = JSON.parse(event.target.dataset["variant"] || "{}");
            const variantAlt = variants.featured_image
                ? variants.featured_image.alt
                : null;

            // Check if we're on a desktop view
            const isDesktop = window.innerWidth > 768;

            // Handle desktop-specific behavior
            if (isDesktop) {
                const gallery = document.querySelector(".product-gallery"); // Select the product gallery

                if (gallery) {
                    const allImages = gallery.querySelectorAll("img"); // Select all images within the gallery

                    // Hide all images in the product gallery
                    allImages.forEach((img) => {
                        img.style.display = "none";
                    });

                    // Find and show matching images (by selected option or "All")
                    const matchingImages = gallery.querySelectorAll(
                        `img[alt="${option1}"], img[alt="All"]`
                    );
                    matchingImages.forEach((img) => {
                        img.style.display = "block"; // Show matching images
                    });
                }
            } else {
                // On mobile, ensure all images are visible
                const gallery = document.querySelector(".product-gallery");
                if (gallery) {
                    const allImages = gallery.querySelectorAll("img");
                    allImages.forEach((img) => {
                        img.style.display = "block"; // Show all images on mobile
                    });
                }
            }
        }

        if (option2 != "") {
            const sizeElement = document.getElementById("sizetext");
            if (sizeElement) {
                sizeElement.innerHTML = option2;
            } else {
                const waistElement = document.getElementById("waisttext");
                if (waistElement) {
                    waistElement.innerHTML = option2;
                }
            }
            document.querySelector(
                "#swatch-1-" +
                option2.toLowerCase().replace("/", "-") +
                "-" +
                product.id
            ).checked = true;
        }
        if (option3 != "") {
            document.getElementById("inseamtext").innerHTML = option3;
        }

        var inventory_quantity = qty.find(
            (item) => item.id === variant.id
        ).inventory_quantity;
        var sku = variant.sku;

        // console.log("Button checked:", variant);

        // SKU
        document.getElementsByClassName("sku")[0].innerHTML = sku;

        // URL
        const url = new URL(window.location.href);
        if (variant.id) url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);

        // current price
        if (variant.price > 0) {
            document.getElementsByClassName("current_price")[0].innerHTML =
                '<span class="money">' +
                Shopify.formatMoney(variant.price, $("body").data("money-format")) +
                "</span>";
        } else {
            document.getElementsByClassName("current_price")[0].innerHTML =
                window.PXUTheme.translation.free_price_text;
        }

        // Saving price
        if (variant && variant.available == true) {
            if (variant.price < variant.compare_at_price) {
                document.getElementsByClassName("current_price")[0].innerHTML =
                    '<span class="money">' +
                    Shopify.formatMoney(variant.price, $("body").data("money-format")) +
                    "</span>";
                document.getElementsByClassName("savings")[0].innerHTML =
                    "Regularly " +
                    '<span class="money">' +
                    Shopify.formatMoney(
                        variant.compare_at_price,
                        $("body").data("money-format")
                    ) +
                    "</span>";
                document
                    .getElementsByClassName("current_price")[0]
                    .parentElement.classList.add("sale");
            } else {
                if (document.getElementsByClassName("was-price").length > 0) {
                    document.getElementsByClassName("was-price")[0].innerHTML = "";
                }
                if (document.getElementsByClassName("savings").length > 0) {
                    document.getElementsByClassName("savings")[0].innerHTML = "";
                }
                document
                    .getElementsByClassName("current_price")[0]
                    .parentElement.classList.remove("sale");
            }
            $("[data-add-to-cart-trigger]", $product)
                .removeClass("disabled")
                .removeAttr("disabled")
                .find("span:not(.icon)")
                .text($("[data-add-to-cart-trigger]", $product).data("label"));
            $(".shopify-payment-button", $product).show();
            $(".purchase-details__quantity", $product).show();
        } else {
        }

        // Addd to cart update
        document
            .getElementById("product-select-" + product.id)
            .children.forEach(function (item) {
                if (item.value == variant.id.toString()) item.selected = true;
            });

        // Update quantity box
        document.querySelector(".has-quantity-box .quantity-input").max =
            inventory_quantity;

        // Pre-order update
        const selectedVariant = qty.find((item) => item.id === variant.id);
        if (
            selectedVariant.inventory_management &&
            selectedVariant.inventory_quantity > 0
        ) {
            if (window.PXUTheme.theme_settings.display_inventory_left) {
                var items_left_text = window.PXUTheme.translation.product_count_other;

                if (selectedVariant.inventory_quantity == 1) {
                    items_left_text = window.PXUTheme.translation.product_count_one;
                }

                // if (selectedVariant.inventory_quantity <= inventoryThreshold) {
                if (selectedVariant.inventory_quantity > 0) {
                  if (selectedVariant.inventory_quantity > 5) {
                    $(".items_left", $product).html(
                        "5 " + items_left_text
                    );
                  } else {
                    $(".items_left", $product).html(
                        selectedVariant.inventory_quantity + " " + items_left_text
                    );
                  }
                } else {
                    $(".items_left", $product).html("");
                }
            }

            if (selectedVariant.inventory_policy == "deny") {
                $("[data-max-inventory-management]", $product).attr(
                    "max",
                    selectedVariant.inventory_quantity
                ); // Check to see if quantity selector should be disabled based on inventory remaining

                window.PXUTheme.quantityBox.updateQuantityControls(
                    $(".quantity-input")
                );
            }
            // console.log("In Stock");
            $("#pd-add-to-cart").text("Add to Cart");
            $(".preorder-date__wrapper").text(" ");
        } else {
            // console.log("Coming Here");
            if (shipDate) {
                $("#pd-add-to-cart").text("Pre-Order Now!");
                $(".preorder-date__wrapper").text("Estimated to ship " + shipDate);
                document
                    .querySelector(".has-quantity-box .quantity-input")
                    .removeAttribute("max");
            } else {
                $("#pd-add-to-cart").text("Add to Cart");
                $(".preorder-date__wrapper").text(" ");
            }

            $(".items_left", $product).text("");
            $("[data-max-inventory-management]", $product).removeAttr("max");
        }
    } else {
        // console.log("Button unchecked:", variant);
        // Add your custom logic here
    }
}

// Add event listeners to each button
buttons.forEach((button) => {
    button.addEventListener("change", handleButtonChange);
});
// Product "Gift Card" ID:7466982670558
if (product.id == 7466982670558) {
    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === "childList") {
                // Check if the specific element is added
                const productSelectElement = document.getElementById(
                    "product-select-" + product.id + "-option-0"
                );
                if (productSelectElement) {
                    // Attach the event listener
                    productSelectElement.addEventListener("change", function (event) {
                        document.querySelector(".current_price .money").innerHTML =
                            event.target.selectedOptions[0].innerHTML;
                    });
                    // Once the element is found and event listener is attached, disconnect the observer
                    observer.disconnect();
                }
            }
        });
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
}
$("body").on(
    "change",
    ".swatch :radio.option_index-0, .swatch :radio.option_index-1",
    function () {
        var optionIndex = $(this).closest(".swatch").attr("data-option-index");
        var parentForm = $(this).closest(".product_form form");

        var notifyForm = parentForm.siblings(".notify_form").length
            ? parentForm.siblings(".notify_form")
            : $(".js-notify-form");

        var option1 = parentForm.find(".swatch_options input:checked").eq(0).val();
        var option2 =
            parentForm.find(".swatch_options input:checked").eq(1).val() || "";
        var option3 =
            parentForm.find(".swatch_options input:checked").eq(2).val() || "";

        var notifyMessage = option1;
        if (option1 && option2) {
            notifyMessage += " / " + option2;
        }
        if (option1 && option2 && option3) {
            notifyMessage += " / " + option3;
        }
        notifyForm
            .find(".notify_form_message")
            .attr(
                "value",
                notifyForm.find(".notify_form_message").data("body") +
                " - " +
                notifyMessage
            );

        if (optionIndex == "0") {
            updateOptionsInSelector(1, parent, option1);
            updateOptionsInSelector(2, parent, option2);

            if (option2) {
                var availableOptions = optionsMap[option1];
                var sizeChecked = false;
                var variant =
                    product.variants.find(
                        (item) =>
                            item.title === (option1 + " / " + option2) && item.available
                    ) ||
                    product.variants.find(
                        (item) => item.title.startsWith(option1 + " /") && item.available
                    );
                var tempOption2 = null;
                $(
                    parent + ' .swatch[data-option-index="' + 1 + '"] .swatch-element'
                ).each(function () {
                    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled")
                            .removeAttr("checked");

                        if ($(this).attr("data-value") === variant.option2) {
                            this.previousElementSibling.checked = true;
                            tempOption2 = variant.option2;
                            sizeChecked = true;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");
                        this.previousElementSibling.checked = false;
                    }
                });
            }

            // Re-apply size hiding for the newly selected color (accentuate.hide_size).
            applyHideSizeForColor(option1);

            if (option3) {
                var availableOptions =
                    optionsMap[
                    option1 + " / " + (tempOption2 != null ? tempOption2 : option2)
                    ];
                var sizeChecked = false;
                var variant =
                    product.variants.find(
                        (item) => item.title === notifyMessage && item.available
                    ) ||
                    product.variants.find(
                        (item) =>
                            item.title === (option1 + " / " + option2) && item.available
                    );
                $(
                    parent + ' .swatch[data-option-index="' + 2 + '"] .swatch-element'
                ).each(function () {
                    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled")
                            .removeAttr("checked");

                        if (
                            $(this).attr("data-value") ===
                            (variant !== undefined ? variant.option3 : availableOptions[0])
                        ) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");
                        this.previousElementSibling.checked = false;
                    }
                });
            }
        }

        if (optionIndex == "1") {
            updateOptionsInSelector(2, parent, option2);

            if (option3) {
                var availableOptions = optionsMap[option1 + " / " + option2];
                var sizeChecked = false;
                var variant =
                    product.variants.find(
                        (item) => item.title === notifyMessage && item.available
                    ) ||
                    product.variants.find(
                        (item) =>
                            item.title === (option1 + " / " + option2) && item.available
                    );
                $(
                    parent + ' .swatch[data-option-index="' + 2 + '"] .swatch-element'
                ).each(function () {
                    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled")
                            .removeAttr("checked");

                        if ($(this).attr("data-value") === variant.option3) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");
                        this.previousElementSibling.checked = false;
                    }
                });
            }
        }
    }
); // Swatches linked with selected options

updateOptionsInSelector = function (selectorIndex, parent) {
    switch (selectorIndex) {
        case 0:
            var key = "root";
            var selector = $(parent + " .single-option-selector:eq(0)");
            break;

        case 1:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            var selector = $(parent + " .single-option-selector:eq(1)");
            break;

        case 2:
            var key = $(parent + " .single-option-selector:eq(0)").val();
            key += " / " + $(parent + " .single-option-selector:eq(1)").val();
            var selector = $(parent + " .single-option-selector:eq(2)");
    }

    var availableOptions =
        optionsMap[key] ||
        optionsMap[
        key.split(" / ")[0] + " / " + optionsMap[key.split(" / ")[0]]
        ];
    $(
        parent +
        ' .swatch[data-option-index="' +
        selectorIndex +
        '"] .swatch-element'
    ).each(function () {
        if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
            $(this)
                .removeClass("soldout")
                .find(":radio")
                .removeAttr("disabled", "disabled")
                .removeAttr("checked");
        } else {
            $(this)
                .addClass("soldout")
                .find(":radio")
                .removeAttr("checked")
                .attr("disabled", "disabled");
        }
    });
};

// Create a MutationObserver to watch for changes in the DOM
const observer34 = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
            // Check if the specific element is added
            const productSelectElement = document.getElementById(
                "product-select-" + product.id + "-option-0"
            );
            if (productSelectElement) {
                // Attach the event listener
                productSelectElement.addEventListener("change", function (event) {
                    document.querySelector(".current_price .money").innerHTML =
                        event.target.selectedOptions[0].innerHTML;
                });
                // Once the element is found and event listener is attached, disconnect the observer
                observer34.disconnect();
            }
        }
    });
});

// Start observing the document body for added nodes
observer34.observe(document.body, { childList: true, subtree: true });